import { useDroppable } from '@dnd-kit/core';
import 'react';
import { DroppableContainer } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

function Droppable(props) {
  const {
    id,
    draggableId,
    zIndex
  } = props;
  const {
    active,
    setNodeRef
  } = useDroppable({
    id: `${id}-droppable`
  });
  const isActive = (active === null || active === void 0 ? void 0 : active.id) === `${draggableId}-draggable`;
  return jsx(DroppableContainer, {
    ref: setNodeRef,
    style: {
      ...(isActive && {
        left: 0,
        top: 0,
        zIndex,
        width: '100%',
        height: '100%'
      })
    },
    children: props === null || props === void 0 ? void 0 : props.children
  });
}

export { Droppable as default };
